var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeminari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18125_12182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18125_12182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21C10.877 20.0845 9.63658 19.362 8.27875 18.8325C6.92108 18.303 5.49483 17.987 4 17.8845V8.53825C5.5295 8.62808 6.98267 8.99317 8.3595 9.6335C9.7365 10.2738 10.95 11.0665 12 12.0115C13.05 11.0665 14.2635 10.2738 15.6405 9.6335C17.0173 8.99317 18.4705 8.62808 20 8.53825V17.8845C18.5013 17.987 17.0741 18.303 15.7182 18.8325C14.3624 19.362 13.123 20.0845 12 21ZM12 8.4615C11.1052 8.4615 10.343 8.14675 9.7135 7.51725C9.084 6.88775 8.76925 6.12558 8.76925 5.23075C8.76925 4.33575 9.084 3.5735 9.7135 2.944C10.343 2.31467 11.1052 2 12 2C12.8948 2 13.657 2.31467 14.2865 2.944C14.916 3.5735 15.2308 4.33575 15.2308 5.23075C15.2308 6.12558 14.916 6.88775 14.2865 7.51725C13.657 8.14675 12.8948 8.4615 12 8.4615Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeminari);
export default __webpack_public_path__ + "static/media/seminari.aaf3588f2b533eafd188808b82f9d381.svg";
export { ForwardRef as ReactComponent };